// This catalog owns section IDs, routes and navigation labels. The client copy is generated.
export const SECTION_CATALOG = [
  { id: 'positions', path: '/positions', label: 'Позиции', icon: 'solar:graph-up-bold-duotone' },
  { id: 'metrics', path: '/metrics', label: 'Метрики', icon: 'solar:chart-2-bold-duotone' },
  { id: 'alerts', path: '/alerts', label: 'Алерты', icon: 'solar:bell-bing-bold-duotone' },
  { id: 'reports', path: '/reports', label: 'Отчёты', icon: 'solar:document-text-bold-duotone' },
  { id: 'registry', path: '/registry', label: 'Реестр', icon: 'solar:database-bold-duotone' },
  { id: 'donors', path: '/donors', label: 'Доноры', icon: 'solar:link-round-bold-duotone' },
  { id: 'fakes', path: '/search-map', label: 'Карта выдачи', icon: 'solar:map-bold-duotone' },
  { id: 'jobs', path: '/jobs', label: 'Фоновые операции', icon: 'solar:checklist-bold-duotone' },
  { id: 'telegram', path: '/telegram', label: 'Телеграм', icon: 'solar:plain-2-bold-duotone' },
  {
    id: 'shorts',
    path: '/shorts',
    label: 'Шортсы',
    icon: 'solar:video-frame-play-horizontal-bold-duotone',
  },
  { id: 'settings', path: '/settings', label: 'Настройки', icon: 'solar:settings-bold-duotone' },
  { id: 'documentation', path: '/docs', label: 'Документация', icon: 'solar:book-2-bold-duotone' },
] as const;

export type SectionId = (typeof SECTION_CATALOG)[number]['id'];

export function sectionById(id: SectionId) {
  return SECTION_CATALOG.find((section) => section.id === id)!;
}

export interface SectionVisibility {
  id: SectionId;
  visible: boolean;
  revision: number;
}

export function validateSectionVisibility(value: unknown): SectionVisibility[] {
  if (
    !Array.isArray(value) ||
    value.length !== SECTION_CATALOG.length ||
    !SECTION_CATALOG.every(({ id }) => value.filter((row) => row?.id === id).length === 1) ||
    value.some(
      (row) =>
        typeof row.visible !== 'boolean' || !Number.isSafeInteger(row.revision) || row.revision < 1,
    )
  ) {
    throw new Error('Настройки разделов неполные или повреждены. Обратитесь к администратору.');
  }
  return value as SectionVisibility[];
}
